const mediaItems = [
  {
    title: '本周娱乐圈大事件快速回顾',
    desc: '五分钟速览本周最热门的娱乐圈事件，从恋情曝光到综艺争议，一个视频看完所有精彩看点。',
    duration: '05:28',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20weekly%20entertainment%20news%20recap%20video%20thumbnail%2C%20warm%20coral%20and%20gold%20gradient%20background%2C%20geometric%20play%20button%20overlay%2C%20clean%20modern%20design%20with%20flowing%20shapes%2C%20cinematic%20warm%20atmosphere&width=720&height=480&seq=media-01&orientation=landscape',
  },
  {
    title: '明星专访精华：那些你不知道的背后故事',
    desc: '独家整理多位明星近期专访中的精彩爆料，台前幕后的真实一面，吃瓜群众的必看内容。',
    duration: '08:15',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20celebrity%20interview%20highlights%20video%20thumbnail%2C%20warm%20peach%20and%20soft%20amber%20palette%2C%20geometric%20microphone%20and%20spotlight%20elements%2C%20clean%20editorial%20composition%2C%20warm%20studio%20atmosphere&width=720&height=480&seq=media-02&orientation=landscape',
  },
  {
    title: '综艺名场面合集：笑点与泪点齐飞',
    desc: '近期热门综艺中最令人印象深刻的瞬间，从爆笑桥段到感人时刻，带你重温那些精彩名场面。',
    duration: '06:42',
    views: '85万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20variety%20show%20highlight%20moments%20video%20thumbnail%2C%20warm%20golden%20and%20coral%20tones%2C%20geometric%20laughing%20face%20and%20star%20elements%2C%20modern%20editorial%20design%20with%20dynamic%20shapes&width=720&height=480&seq=media-03&orientation=landscape',
  },
  {
    title: '网红圈最新动态深度解析',
    desc: '从直播带货到内容创作，深度解析网红经济的最新趋势和头部创作者的发展动向。',
    duration: '10:30',
    views: '72万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20influencer%20industry%20analysis%20video%20thumbnail%2C%20warm%20coral%20and%20amber%20palette%2C%20geometric%20chart%20and%20trend%20line%20elements%2C%20clean%20modern%20editorial%20design%2C%20professional%20atmosphere&width=720&height=480&seq=media-04&orientation=landscape',
  },
  {
    title: '影视新作预告片全解读',
    desc: '即将上映和播出的影视作品预告合集，从制作班底到剧情前瞻，帮你提前锁定必看作品。',
    duration: '07:55',
    views: '63万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20movie%20trailer%20analysis%20video%20thumbnail%2C%20warm%20golden%20and%20soft%20coral%20tones%2C%20geometric%20film%20strip%20and%20clapperboard%20elements%2C%20cinematic%20editorial%20design%2C%20theater%20atmosphere&width=720&height=480&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">吃瓜视频</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              精选热门吃瓜视频内容，涵盖娱乐八卦、综艺名场面、明星专访等多元视频资讯
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item, idx) => (
              <a
                key={idx}
                href="#media"
                onClick={(e) => handleNavClick(e, '#media')}
                className={`group block bg-background-100 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer ${
                  idx === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
                }`}
              >
                <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl md:text-2xl text-primary-500 group-hover:text-background-50 ml-0.5 transition-colors"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-foreground-950/70 text-background-50 text-xs font-medium">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {item.views}
                    </span>
                    <span>播放</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}